/**
 * Frutos Collection — Catálogo completo + filtros inteligentes v4
 * Carga TODOS los productos vía /collections/{handle}/products.json
 */
(function () {
  'use strict';

  var CFG = window.FC_FILTER_CONFIG || {};

  var catalog = {
    products: [],
    loaded: false,
    loading: false,
    initialGridHtml: ''
  };

  var state = {
    searchQuery: '',
    customPrice: { min: null, max: null },
    sortBy: CFG.sortBy || 'manual'
  };

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  /** Precio AJAX Shopify: "12000.00" | display: "12.000,00" → pesos enteros */
  function parseAjaxPrice(val) {
    if (val == null || val === '' || val === '0' || val === 0) return NaN;
    var s = String(val).trim();
    if (/^\d+(\.\d+)?$/.test(s)) {
      return Math.round(parseFloat(s));
    }
    return parseShopifyCop(s);
  }

  function parseShopifyCop(text) {
    if (text === null || text === undefined || text === '') return NaN;
    var s = String(text).replace(/\s/g, '').replace(/^\$/, '').trim();
    if (!s) return NaN;
    if (s.indexOf(',') !== -1) {
      var parts = s.split(',');
      return Math.round(parseFloat(parts[0].replace(/\./g, '') + '.' + (parts[1] || '0').substring(0, 2)));
    }
    if (s.indexOf('.') !== -1) {
      var segs = s.split('.');
      if (segs.length > 1 && segs[segs.length - 1].length === 3 && segs.length >= 2) {
        return parseInt(s.replace(/\./g, ''), 10);
      }
      return Math.round(parseFloat(s));
    }
    return parseInt(s, 10);
  }

  function formatPricePesos(pesos) {
    if (isNaN(pesos)) return '';
    return formatCop(pesos);
  }

  function formatCop(amount) {
    if (isNaN(amount)) return '';
    return '$' + Math.round(amount).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function formatCopInput(amount) {
    if (isNaN(amount)) return '';
    return Math.round(amount).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, CFG.moneyFormat || '${{amount}}');
    }
    return formatCop(Math.round(cents / (getPriceDivisor())));
  }

  function getPriceDivisor() {
    return 100;
  }

  function rawToPesos(raw) {
    if (isNaN(raw)) return 0;
    return Math.round(raw / 100);
  }

  function stripHtml(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    return (d.textContent || '').trim();
  }

  function truncateWords(text, n) {
    var words = (text || '').split(/\s+/).filter(Boolean);
    if (words.length <= n) return words.join(' ');
    return words.slice(0, n).join(' ') + '…';
  }

  function imageUrl(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    var base = src.split('?')[0];
    return base + '?width=' + (width || 600);
  }

  function extractVariantPrices(variants) {
    var prices = [];
    var compares = [];
    var anyAvailable = false;
    var firstId = null;

    (variants || []).forEach(function (v) {
      var p = parseAjaxPrice(v.price);
      if (!isNaN(p)) prices.push(p);
      var c = parseAjaxPrice(v.compare_at_price);
      if (!isNaN(c) && c > 0) compares.push(c);
      if (v.available) {
        anyAvailable = true;
        if (!firstId) firstId = v.id;
      }
      if (!firstId) firstId = v.id;
    });

    if (!prices.length) prices.push(0);

    return {
      minPesos: Math.min.apply(null, prices),
      maxPesos: Math.max.apply(null, prices),
      comparePesos: compares.length ? Math.max.apply(null, compares) : 0,
      available: anyAvailable,
      firstVariantId: firstId
    };
  }

  function normalizeProduct(raw, index) {
    var tags = [];
    if (Array.isArray(raw.tags)) {
      tags = raw.tags;
    } else if (typeof raw.tags === 'string' && raw.tags.trim()) {
      tags = raw.tags.split(',');
    }
    tags = tags.map(function (t) { return String(t).toLowerCase().trim(); }).filter(Boolean);

    var productType = raw.product_type || raw.type || '';
    var typeLower = String(productType).toLowerCase().trim();

    var variants = raw.variants || [];
    var vp = extractVariantPrices(variants);
    var created = new Date(raw.created_at || Date.now());
    var days = (Date.now() - created.getTime()) / 86400000;
    var hasDiscount = vp.comparePesos > vp.minPesos;

    return {
      id: raw.id,
      title: raw.title || '',
      handle: raw.handle || '',
      vendor: raw.vendor || '',
      vendorLower: (raw.vendor || '').toLowerCase().trim(),
      tags: tags,
      productType: productType,
      typeLower: typeLower,
      bodyText: truncateWords(stripHtml(raw.body_html || ''), 12),
      available: raw.available != null ? !!raw.available : vp.available,
      priceMinPesos: vp.minPesos,
      priceMaxPesos: vp.maxPesos,
      compareAtPesos: vp.comparePesos,
      onSale: hasDiscount,
      isNew: days < 30,
      isOrganic: tags.some(function (t) { return /organico|orgánico|organic/.test(t); }),
      isFeatured: tags.some(function (t) { return /destacado|featured/.test(t); }),
      images: raw.images || [],
      variants: variants,
      firstVariantId: vp.firstVariantId,
      url: '/products/' + raw.handle,
      sortIndex: index,
      createdAt: created.getTime()
    };
  }

  function hydrateFromDom() {
    var cards = document.querySelectorAll('#fcGrid .fc-card');
    return Array.from(cards).map(function (card, index) {
      var tags = (card.dataset.fcTags || '').split(',').filter(Boolean);
      var minCents = parseInt(card.dataset.fcPriceMinCents, 10);
      var maxCents = parseInt(card.dataset.fcPriceMaxCents, 10);
      var minPesos = !isNaN(minCents) ? rawToPesos(minCents) : 0;
      var maxPesos = !isNaN(maxCents) ? rawToPesos(maxCents) : minPesos;
      var addBtn = card.querySelector('.fc-add-btn');
      var titleEl = card.querySelector('.fc-card__title');
      var descEl = card.querySelector('.fc-card__desc');

      return {
        id: card.querySelector('.fc-variant-select') ? card.querySelector('.fc-variant-select').dataset.productId : index,
        title: card.dataset.title || (titleEl ? titleEl.textContent : ''),
        handle: card.dataset.fcHandle || '',
        vendor: card.dataset.vendor || '',
        vendorLower: (card.dataset.fcVendor || card.dataset.vendor || '').toLowerCase().trim(),
        tags: tags,
        productType: card.dataset.fcType || '',
        typeLower: (card.dataset.fcType || '').toLowerCase().trim(),
        bodyText: card.dataset.desc || (descEl ? descEl.textContent : ''),
        available: card.dataset.fcAvailable === 'true',
        priceMinPesos: minPesos,
        priceMaxPesos: maxPesos,
        compareAtPesos: 0,
        onSale: card.dataset.fcOnSale === 'true',
        isNew: card.dataset.fcIsNew === 'true',
        isOrganic: card.dataset.fcIsOrganic === 'true',
        isFeatured: card.dataset.fcIsFeatured === 'true',
        images: [],
        variants: [],
        firstVariantId: addBtn ? addBtn.dataset.vid : null,
        url: card.dataset.fcHandle ? '/products/' + card.dataset.fcHandle : '#',
        sortIndex: index,
        createdAt: 0,
        _domHtml: card.outerHTML
      };
    });
  }

  function fetchCatalogPage(handle, page) {
    var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page;
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('No se pudo cargar el catálogo');
      return r.json();
    });
  }

  function fetchAllProducts() {
    if (catalog.loading || catalog.loaded) {
      return Promise.resolve(catalog.products);
    }
    catalog.loading = true;
    showGridLoading(true);

    var handle = CFG.collectionHandle || 'all';
    var page = 1;
    var all = [];

    function next() {
      return fetchCatalogPage(handle, page).then(function (data) {
        var batch = data.products || [];
        all = all.concat(batch);
        if (batch.length === 250) {
          page += 1;
          return next();
        }
        catalog.products = all.map(function (item, idx) {
          try { return normalizeProduct(item, idx); }
          catch (e) { console.warn('[FC] Product skip:', e); return null; }
        }).filter(Boolean);

        if (!catalog.products.length) {
          throw new Error('Catálogo vacío desde API');
        }

        catalog.loaded = true;
        catalog.loading = false;
        buildFacets();
        showGridLoading(false);
        return catalog.products;
      });
    }

    return next().catch(function (err) {
      console.warn('[FC] API fallback DOM:', err);
      catalog.loading = false;
      showGridLoading(false);
      catalog.products = hydrateFromDom();
      catalog.loaded = catalog.products.length > 0;
      if (catalog.loaded) buildFacets();
      return catalog.products;
    });
  }

  function showGridLoading(on) {
    var el = $('#fcGridLoading');
    if (el) el.classList.toggle('is-visible', !!on);
    var grid = $('#fcGrid');
    if (grid) grid.classList.toggle('is-loading', !!on);
  }

  function setPaginationVisible(show) {
    var nav = $('#fcPagination');
    if (nav) nav.style.display = show ? '' : 'none';
  }

  /* ── Facetas dinámicas ── */
  function buildFacets() {
    var typeMap = {};
    var vendorMap = {};
    var counts = { in_stock: 0, out_of_stock: 0, on_sale: 0, new: 0, organic: 0, featured: 0 };
    var minRaw = Infinity;
    var maxRaw = 0;

    catalog.products.forEach(function (p) {
      if (p.typeLower) {
        typeMap[p.typeLower] = typeMap[p.typeLower] || { label: p.productType, count: 0 };
        typeMap[p.typeLower].count += 1;
      }
      if (p.vendorLower) {
        vendorMap[p.vendorLower] = vendorMap[p.vendorLower] || { label: p.vendor, count: 0 };
        vendorMap[p.vendorLower].count += 1;
      }
      if (p.available) counts.in_stock += 1;
      else counts.out_of_stock += 1;
      if (p.onSale) counts.on_sale += 1;
      if (p.isNew) counts.new += 1;
      if (p.isOrganic) counts.organic += 1;
      if (p.isFeatured) counts.featured += 1;
      minRaw = Math.min(minRaw, p.priceMinPesos);
      maxRaw = Math.max(maxRaw, p.priceMaxPesos);
    });

    var types = Object.keys(typeMap).sort(function (a, b) {
      return typeMap[a].label.localeCompare(typeMap[b].label, 'es');
    });
    var vendors = Object.keys(vendorMap).sort(function (a, b) {
      return vendorMap[a].label.localeCompare(vendorMap[b].label, 'es');
    });

    $$('[data-fc-facet-list="types"]').forEach(function (ul) {
      var ctx = ul.getAttribute('data-fc-context') || 'sidebar';
      if (!types.length) {
        ul.innerHTML = '<li class="fc-filter-empty">Sin categorías en esta colección</li>';
        return;
      }
      ul.innerHTML = types.map(function (typeKey) {
        var t = typeMap[typeKey];
        var fid = 'fc-type-' + ctx + '-' + typeKey.replace(/[^a-z0-9]/gi, '-');
        return '<li><label><input type="checkbox" value="' + escapeHtml(t.label) + '" id="' + fid + '" data-fc-filter="type-' + escapeHtml(typeKey) + '" data-fc-filter-group="types"><span>' + escapeHtml(t.label) + '</span><span class="fc-tag-count">' + t.count + '</span></label></li>';
      }).join('');
    });

    $$('[data-fc-facet-list="vendors"]').forEach(function (ul) {
      var ctx = ul.getAttribute('data-fc-context') || 'sidebar';
      var block = ul.closest('[data-fc-facet-block]');
      if (!vendors.length) {
        if (block) block.setAttribute('hidden', '');
        return;
      }
      if (block) block.removeAttribute('hidden');
      ul.innerHTML = vendors.map(function (vk) {
        var v = vendorMap[vk];
        var fid = 'fc-vendor-' + ctx + '-' + vk.replace(/[^a-z0-9]/gi, '-');
        return '<li><label><input type="checkbox" value="' + escapeHtml(vk) + '" id="' + fid + '" data-fc-filter="vendor-' + escapeHtml(vk) + '" data-fc-filter-group="vendors"><span>' + escapeHtml(v.label) + '</span><span class="fc-tag-count">' + v.count + '</span></label></li>';
      }).join('');
    });

    Object.keys(counts).forEach(function (key) {
      $$('[data-fc-facet-count="' + key + '"]').forEach(function (el) {
        el.textContent = String(counts[key]);
      });
    });

    if (minRaw !== Infinity) {
      var hint = 'Catálogo: ' + formatCop(minRaw) + ' – ' + formatCop(maxRaw);
      $$('[data-fc-catalog-hint]').forEach(function (el) {
        el.innerHTML = hint + '<br><span class="fc-price-custom__format">Ej: 12.000 o 12.000,00 · ' + catalog.products.length + ' productos</span>';
      });
    }
  }

  /* ── Filtros ── */
  function syncInputs() {
    var sidebar = $('#fcSidebar');
    var mobile = $('#fcMobilePanel');
    if (!sidebar || !mobile) return;
    var active = document.activeElement;
    var source = active && active.closest('#fcMobilePanel') ? mobile : sidebar;
    var target = source === mobile ? sidebar : mobile;
    $$('[data-fc-filter]', source).forEach(function (input) {
      var key = input.getAttribute('data-fc-filter');
      if (!key) return;
      var peer = $('[data-fc-filter="' + key + '"]', target);
      if (!peer || peer === input) return;
      if (input.type === 'checkbox' || input.type === 'radio') peer.checked = input.checked;
      else peer.value = input.value;
    });
  }

  function readCheckedValues(group) {
    var seen = {};
    var out = [];
    document.querySelectorAll('input[data-fc-filter-group="' + group + '"]:checked').forEach(function (el) {
      if (!seen[el.value]) { seen[el.value] = true; out.push(el.value); }
    });
    return out;
  }

  function getCustomPriceValues() {
    var minVal = null;
    var maxVal = null;
    document.querySelectorAll('[data-fc-filter="price-min"]').forEach(function (el) {
      if (el.value !== '') minVal = parseShopifyCop(el.value);
    });
    document.querySelectorAll('[data-fc-filter="price-max"]').forEach(function (el) {
      if (el.value !== '') maxVal = parseShopifyCop(el.value);
    });
    return { min: minVal, max: maxVal };
  }

  function readFilterState() {
    var priceRadio = document.querySelector('input[data-fc-filter-group="price"]:checked');
    var custom = getCustomPriceValues();
    var priceRange = null;

    if (priceRadio) {
      priceRange = {
        min: parseInt(priceRadio.getAttribute('data-min'), 10) || 0,
        max: parseInt(priceRadio.getAttribute('data-max'), 10) || 999999999,
        label: priceRadio.getAttribute('data-label') || ''
      };
    } else if (state.customPrice.min !== null || state.customPrice.max !== null) {
      priceRange = {
        min: state.customPrice.min !== null ? state.customPrice.min : 0,
        max: state.customPrice.max !== null ? state.customPrice.max : 999999999,
        label: formatCop(state.customPrice.min || 0) + ' – ' + formatCop(state.customPrice.max || 999999999),
        custom: true
      };
    } else if (custom.min !== null || custom.max !== null) {
      priceRange = {
        min: custom.min !== null ? custom.min : 0,
        max: custom.max !== null ? custom.max : 999999999,
        label: formatCop(custom.min || 0) + ' – ' + formatCop(custom.max || 999999999),
        custom: true
      };
    }

    return {
      types: readCheckedValues('types'),
      vendors: readCheckedValues('vendors'),
      availability: readCheckedValues('availability'),
      features: readCheckedValues('features'),
      priceRange: priceRange,
      searchQuery: state.searchQuery
    };
  }

  function priceOverlapsProduct(p, fmin, fmax) {
    var pmin = p.priceMinPesos || 0;
    var pmax = p.priceMaxPesos || pmin;
    if (p._currentPricePesos != null) {
      return p._currentPricePesos >= fmin && p._currentPricePesos <= fmax;
    }
    return pmax >= fmin && pmin <= fmax;
  }

  function productMatches(p, filters) {
    if (filters.searchQuery) {
      var q = filters.searchQuery.toLowerCase();
      var blob = (p.title + ' ' + p.vendor + ' ' + p.bodyText + ' ' + p.tags.join(' ') + ' ' + p.productType).toLowerCase();
      if (blob.indexOf(q) === -1) return false;
    }
    if (filters.types.length && filters.types.indexOf(p.typeLower) === -1) return false;
    if (filters.vendors.length && filters.vendors.indexOf(p.vendorLower) === -1) return false;
    if (filters.availability.length) {
      var ok = false;
      if (filters.availability.indexOf('in_stock') !== -1 && p.available) ok = true;
      if (filters.availability.indexOf('out_of_stock') !== -1 && !p.available) ok = true;
      if (!ok) return false;
    }
    if (filters.features.length) {
      var feat = false;
      if (filters.features.indexOf('on_sale') !== -1 && p.onSale) feat = true;
      if (filters.features.indexOf('new') !== -1 && p.isNew) feat = true;
      if (filters.features.indexOf('organic') !== -1 && p.isOrganic) feat = true;
      if (filters.features.indexOf('featured') !== -1 && p.isFeatured) feat = true;
      if (!feat) return false;
    }
    if (filters.priceRange && !priceOverlapsProduct(p, filters.priceRange.min, filters.priceRange.max)) return false;
    return true;
  }

  function hasActiveFilters(filters) {
    return !!(filters.searchQuery || filters.priceRange || filters.types.length ||
      filters.vendors.length || filters.availability.length || filters.features.length);
  }

  function sortProducts(list) {
    var sorted = list.slice();
    var s = state.sortBy;
    if (s === 'price-ascending') {
      sorted.sort(function (a, b) { return a.priceMinPesos - b.priceMinPesos; });
    } else if (s === 'price-descending') {
      sorted.sort(function (a, b) { return b.priceMinPesos - a.priceMinPesos; });
    } else if (s === 'title-ascending') {
      sorted.sort(function (a, b) { return a.title.localeCompare(b.title, 'es'); });
    } else if (s === 'title-descending') {
      sorted.sort(function (a, b) { return b.title.localeCompare(a.title, 'es'); });
    } else if (s === 'created-descending') {
      sorted.sort(function (a, b) { return b.createdAt - a.createdAt; });
    } else if (s === 'created-ascending') {
      sorted.sort(function (a, b) { return a.createdAt - b.createdAt; });
    } else {
      sorted.sort(function (a, b) { return a.sortIndex - b.sortIndex; });
    }
    return sorted;
  }

  /* ── Render tarjetas ── */
  function buildBadges(p) {
    var html = '';
    if (!p.available) html += '<span class="fc-badge fc-badge--soldout">Agotado</span>';
    if (p.onSale && p.available) {
      var pct = Math.round((p.compareAtPesos - p.priceMinPesos) * 100 / p.compareAtPesos);
      html += '<span class="fc-badge fc-badge--sale">-' + pct + '%</span>';
    }
    if (p.isNew && p.available) html += '<span class="fc-badge fc-badge--new">Nuevo</span>';
    if (p.isFeatured) html += '<span class="fc-badge fc-badge--featured">Destacado</span>';
    if (p.isOrganic) html += '<span class="fc-badge fc-badge--organic">🌿 Orgánico</span>';
    return html;
  }

  function buildVariants(p) {
    if (p.variants.length <= 1) return '';
    var opts = p.variants.map(function (v, i) {
      var price = formatPricePesos(parseAjaxPrice(v.price));
      var comparePesos = parseAjaxPrice(v.compare_at_price);
      var compare = comparePesos > parseAjaxPrice(v.price) ? formatCop(comparePesos) : '';
      return '<option value="' + v.id + '" data-price="' + escapeHtml(price) + '" data-price-raw="' + escapeHtml(String(v.price)) + '" data-compare="' + escapeHtml(compare) + '" data-available="' + v.available + '"' + (i === 0 ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + escapeHtml(v.title) + ' — ' + (v.available ? price : 'Agotado') + '</option>';
    }).join('');
    return '<select class="fc-variant-select" onchange="fcV(this)" data-product-id="' + p.id + '">' + opts + '</select>';
  }

  function renderProductCard(p, index) {
    if (p._domHtml) return p._domHtml;

    var img1 = p.images[0] ? imageUrl(p.images[0].src, 600) : '';
    var img2 = p.images[1] ? imageUrl(p.images[1].src, 600) : '';
    var loading = index < 4 ? 'eager' : 'lazy';
    var price = formatPricePesos(p.priceMinPesos);
    var compareHtml = p.onSale ? '<span class="fc-compare-price" id="fcCompPrice-' + p.id + '">' + formatCop(p.compareAtPesos) + '</span><span class="fc-save-badge" id="fcSave-' + p.id + '">Ahorra ' + Math.round((p.compareAtPesos - p.priceMinPesos) * 100 / p.compareAtPesos) + '%</span>' : '';
    var wa = 'https://wa.me/' + (CFG.wappNumber || '') + '?text=' + encodeURIComponent('¡Hola! Ví ' + p.title + ' en Frutos de la Raíz y quiero más info. ' + (CFG.shopUrl || '') + p.url);

    var imageBlock = img1
      ? '<img src="' + escapeHtml(img1) + '" alt="' + escapeHtml(p.title) + '" class="fc-card__image fc-card__image--first" loading="' + loading + '" width="400" height="400">' +
        (img2 ? '<img src="' + escapeHtml(img2) + '" alt="' + escapeHtml(p.title) + ' — vista 2" class="fc-card__image fc-card__image--second" loading="lazy" width="400" height="400">' : '')
      : '<div class="fc-card__image" style="display:flex;align-items:center;justify-content:center;background:var(--fc-cream);color:var(--fc-text-light);font-size:0.8rem;">Sin imagen</div>';

    return '<article class="fc-card" data-title="' + escapeHtml(p.title) + '" data-vendor="' + escapeHtml(p.vendor) + '" data-desc="' + escapeHtml(p.bodyText) + '" data-tags="' + escapeHtml(p.tags.join(',')) + '" data-fc-tags="' + escapeHtml(p.tags.join(',')) + '" data-fc-type="' + escapeHtml(p.typeLower) + '" data-fc-price-min-cents="' + (p.priceMinPesos * 100) + '" data-fc-price-max-cents="' + (p.priceMaxPesos * 100) + '" data-fc-current-price-cents="' + (p.priceMinPesos * 100) + '" data-fc-available="' + p.available + '" data-fc-vendor="' + escapeHtml(p.vendorLower) + '" data-fc-on-sale="' + p.onSale + '" data-fc-is-new="' + p.isNew + '" data-fc-is-organic="' + p.isOrganic + '" data-fc-is-featured="' + p.isFeatured + '" data-fc-handle="' + escapeHtml(p.handle) + '">' +
      '<a href="' + p.url + '" class="fc-card__image-wrap">' + imageBlock +
      '<div class="fc-badges">' + buildBadges(p) + '</div>' +
      '<div class="fc-card__actions">' +
      '<button type="button" class="fc-action-btn" onclick="event.preventDefault();fcToggleWishlist(\'' + escapeHtml(p.handle) + '\',this)" title="Favoritos" aria-label="Añadir a favoritos"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></button>' +
      '<button type="button" class="fc-action-btn" onclick="event.preventDefault();fcQuickView(\'' + escapeHtml(p.handle) + '\')" title="Vista rápida" aria-label="Vista rápida"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/></svg></button>' +
      '</div><span class="fc-quickview-btn fc-btn fc-btn--primary" onclick="event.preventDefault();fcQuickView(\'' + escapeHtml(p.handle) + '\')" style="font-size:0.78rem;padding:7px 14px;">Vista rápida</span></a>' +
      '<div class="fc-card__info">' +
      (p.vendor ? '<span class="fc-card__vendor">' + escapeHtml(p.vendor) + '</span>' : '') +
      '<a href="' + p.url + '" class="fc-card__title">' + escapeHtml(p.title) + '</a>' +
      (p.bodyText ? '<p class="fc-card__desc">' + escapeHtml(p.bodyText) + '</p>' : '') +
      buildVariants(p) +
      '<div class="fc-price-row" id="fcPrice-' + p.id + '"><span class="fc-price" id="fcCurPrice-' + p.id + '">' + price + '</span>' + compareHtml + '</div>' +
      '<div class="fc-card__buttons">' +
      '<button type="button" class="fc-btn fc-btn--primary fc-add-btn" onclick="fcAdd(this)" data-vid="' + p.firstVariantId + '" data-available="' + p.available + '"' + (p.available ? '' : ' disabled style="opacity:0.5;cursor:not-allowed;"') + ' aria-label="Añadir al carrito"><span class="fc-add-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg></span><span class="fc-add-text">Añadir</span><span class="fc-spinner"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg></span><span class="fc-check"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg></span></button>' +
      '<a href="' + wa + '" class="fc-btn fc-btn--whatsapp" target="_blank" rel="noopener" title="Consultar por WhatsApp" aria-label="Consultar por WhatsApp"><svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg></a>' +
      '</div></div></article>';
  }

  function renderGrid(products) {
    var grid = $('#fcGrid');
    if (!grid) return;
    grid.innerHTML = products.map(renderProductCard).join('');
  }

  function countActiveFilters(filters) {
    return filters.types.length + filters.vendors.length + filters.availability.length +
      filters.features.length + (filters.priceRange ? 1 : 0);
  }

  function updateBadges(filters) {
    var container = $('#fcActiveFilters');
    if (!container) return;
    var html = '';
    filters.types.forEach(function (type) {
      html += '<span class="fc-filter-badge">' + escapeHtml(type) + '<button type="button" data-fc-remove="type" data-value="' + escapeHtml(type) + '">&times;</button></span>';
    });
    filters.vendors.forEach(function (v) {
      html += '<span class="fc-filter-badge">Marca: ' + escapeHtml(v) + '<button type="button" data-fc-remove="vendor" data-value="' + escapeHtml(v) + '">&times;</button></span>';
    });
    filters.availability.forEach(function (a) {
      html += '<span class="fc-filter-badge">' + (a === 'in_stock' ? 'En stock' : 'Agotado') + '<button type="button" data-fc-remove="availability" data-value="' + a + '">&times;</button></span>';
    });
    filters.features.forEach(function (f) {
      var labels = { on_sale: 'En oferta', new: 'Nuevo', organic: 'Orgánico', featured: 'Destacado' };
      html += '<span class="fc-filter-badge">' + (labels[f] || f) + '<button type="button" data-fc-remove="feature" data-value="' + f + '">&times;</button></span>';
    });
    if (filters.priceRange) {
      html += '<span class="fc-filter-badge">' + escapeHtml(filters.priceRange.label) + '<button type="button" data-fc-remove="price">&times;</button></span>';
    }
    if (countActiveFilters(filters) > 0) {
      html += '<button type="button" class="fc-btn fc-btn--ghost" data-fc-remove="all" style="font-size:0.75rem;padding:5px 12px;">Limpiar todo</button>';
    }
    container.innerHTML = html;
    container.style.display = html ? '' : 'none';
  }

  function updateToolbarCount(visible, total) {
    var countEl = $('.fc-toolbar__count');
    if (countEl) {
      var t = total != null ? total : catalog.products.length;
      countEl.textContent = visible + ' de ' + t + ' resultado' + (visible !== 1 ? 's' : '');
    }
    var filters = readFilterState();
    var activeN = countActiveFilters(filters);
    var headCount = $('.fc-filters-active-count');
    if (headCount) headCount.textContent = activeN > 0 ? activeN + ' activo' + (activeN !== 1 ? 's' : '') : '';
    var mobileApply = $('#fcMobileApplyBtn');
    if (mobileApply) mobileApply.textContent = 'Ver ' + visible + ' resultado' + (visible !== 1 ? 's' : '');
  }

  function updateEmptyState(visible, filters) {
    var grid = $('#fcGrid');
    if (!grid) return;
    var emptyEl = $('#fcEmptyDynamic');
    if (visible === 0) {
      if (!emptyEl) {
        emptyEl = document.createElement('div');
        emptyEl.id = 'fcEmptyDynamic';
        emptyEl.className = 'fc-empty';
        grid.parentNode.insertBefore(emptyEl, grid.nextSibling);
      }
      var msg = filters.searchQuery ? 'No encontramos productos para "' + escapeHtml(filters.searchQuery) + '"' : 'Ningún producto coincide con los filtros.';
      emptyEl.innerHTML = '<div class="fc-empty__icon">🔍</div><h2 class="fc-empty__title">Sin resultados</h2><p class="fc-empty__text">' + msg + '</p><button type="button" class="fc-btn fc-btn--primary" data-fc-remove="all">Limpiar filtros</button>';
      emptyEl.style.display = '';
      grid.style.display = 'none';
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      grid.style.display = '';
    }
  }

  function applyFilters() {
    if (!catalog.loaded) return;
    syncInputs();

    var filters = readFilterState();
    var matched = catalog.products.filter(function (p) { return productMatches(p, filters); });
    var sorted = sortProducts(matched);

    if (catalog.products[0] && catalog.products[0]._domHtml && !hasActiveFilters(filters)) {
      var grid = $('#fcGrid');
      if (grid && catalog.initialGridHtml) {
        grid.innerHTML = catalog.initialGridHtml;
        setPaginationVisible(true);
      }
    } else {
      renderGrid(sorted);
      setPaginationVisible(false);
    }

    updateBadges(filters);
    updateToolbarCount(sorted.length, catalog.products.length);
    updateEmptyState(sorted.length, filters);
    document.dispatchEvent(new CustomEvent('fc:filtered', { detail: { visible: sorted.length, total: catalog.products.length, filters: filters } }));
  }

  function clearPriceFilters() {
    state.customPrice = { min: null, max: null };
    document.querySelectorAll('input[data-fc-filter-group="price"]').forEach(function (el) { el.checked = false; });
    document.querySelectorAll('[data-fc-filter="price-min"], [data-fc-filter="price-max"]').forEach(function (el) { el.value = ''; });
  }

  function clearAllFilters() {
    document.querySelectorAll('input[data-fc-filter-group]').forEach(function (el) {
      if (el.type === 'checkbox' || el.type === 'radio') el.checked = false;
    });
    clearPriceFilters();
    state.searchQuery = '';
    var searchInput = $('#fcSearchInput');
    if (searchInput) searchInput.value = '';
    applyFilters();
  }

  function removeFilter(type, value) {
    if (type === 'type') {
      document.querySelectorAll('input[data-fc-filter-group="types"]').forEach(function (el) {
        if (el.value.toLowerCase() === (value || '').toLowerCase()) el.checked = false;
      });
    } else if (type === 'vendor') {
      document.querySelectorAll('input[data-fc-filter-group="vendors"]').forEach(function (el) {
        if (el.value === value) el.checked = false;
      });
    } else if (type === 'availability') {
      document.querySelectorAll('input[data-fc-filter-group="availability"]').forEach(function (el) {
        if (el.value === value) el.checked = false;
      });
    } else if (type === 'feature') {
      document.querySelectorAll('input[data-fc-filter-group="features"]').forEach(function (el) {
        if (el.value === value) el.checked = false;
      });
    } else if (type === 'price') clearPriceFilters();
    applyFilters();
  }

  function onPriceChipChange() {
    state.customPrice = { min: null, max: null };
    document.querySelectorAll('[data-fc-filter="price-min"], [data-fc-filter="price-max"]').forEach(function (el) { el.value = ''; });
    applyFilters();
  }

  function applyCustomPrice() {
    var custom = getCustomPriceValues();
    var minVal = custom.min;
    var maxVal = custom.max;
    if (minVal !== null && maxVal !== null && minVal > maxVal) {
      var tmp = minVal; minVal = maxVal; maxVal = tmp;
    }
    document.querySelectorAll('[data-fc-filter="price-min"]').forEach(function (el) { if (minVal !== null) el.value = formatCopInput(minVal); });
    document.querySelectorAll('[data-fc-filter="price-max"]').forEach(function (el) { if (maxVal !== null) el.value = formatCopInput(maxVal); });
    document.querySelectorAll('input[data-fc-filter-group="price"]').forEach(function (el) { el.checked = false; });
    state.customPrice = { min: minVal, max: maxVal };
    applyFilters();
  }

  function bindEvents() {
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-fc-filter]')) return;
      if (e.target.getAttribute('data-fc-filter-group') === 'price') { onPriceChipChange(); return; }
      applyFilters();
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fc-remove]');
      if (btn) {
        e.preventDefault();
        var type = btn.getAttribute('data-fc-remove');
        if (type === 'all') clearAllFilters();
        else removeFilter(type, btn.getAttribute('data-value') || '');
        return;
      }
      if (e.target.matches('[data-fc-action="apply-price"]')) { e.preventDefault(); applyCustomPrice(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-fc-filter="price-min"], [data-fc-filter="price-max"]')) {
        e.preventDefault(); applyCustomPrice();
      }
    });
    var searchInput = $('#fcSearchInput');
    if (searchInput) {
      var timer = null;
      searchInput.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          state.searchQuery = searchInput.value.trim();
          applyFilters();
        }, 250);
      });
    }
    var sortSel = $('.fc-sort');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        state.sortBy = sortSel.value || 'manual';
        applyFilters();
      });
    }
  }

  window.fcUpdateCardPrice = function (card, priceRaw) {
    if (!card) return;
    var pesos = parseAjaxPrice(priceRaw);
    if (isNaN(pesos)) pesos = parseInt(priceRaw, 10);
    if (isNaN(pesos)) return;

    var handle = card.dataset.fcHandle;
    var p = catalog.products.find(function (x) { return x.handle === handle; });
    if (p) p._currentPricePesos = pesos;

    card.dataset.fcCurrentPriceCents = String(pesos * 100);
    card.dataset.fcVariantActive = 'true';
    applyFilters();
  };

  window.fcF = applyFilters;
  window.fcClr = clearAllFilters;
  window.fcRemoveTag = function (tag) { removeFilter('type', tag); };
  window.fcRemovePrice = function () { removeFilter('price', ''); };
  window.fcRemoveStock = function () { removeFilter('availability', 'in_stock'); };
  window.fcSearch = function (query) { state.searchQuery = (query || '').trim(); applyFilters(); };
  window.fcOpenPanel = function () {
    $('#fcMobilePanel')?.classList.add('is-open');
    $('#fcMobileOverlay')?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  window.fcClosePanel = function () {
    $('#fcMobilePanel')?.classList.remove('is-open');
    $('#fcMobileOverlay')?.classList.remove('is-open');
    document.body.style.overflow = '';
    applyFilters();
  };

  window.FC = window.FC || {};
  window.FC.filters = {
    apply: applyFilters,
    clear: clearAllFilters,
    catalog: catalog,
    fetchAllProducts: fetchAllProducts
  };

  function init() {
    var grid = $('#fcGrid');
    if (grid) catalog.initialGridHtml = grid.innerHTML;

    var params = new URLSearchParams(window.location.search);
    state.sortBy = params.get('sort_by') || CFG.sortBy || 'manual';
    bindEvents();
    fetchAllProducts().then(function () {
      applyFilters();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();